import * as msal from '@azure/msal-browser';

export function msalLoggerCallback(
  level: msal.LogLevel,
  message: string): void {
    switch (level) {
      case msal.LogLevel.Error:
        console.error(message); break;
      case msal.LogLevel.Warning:
        console.warn(message); break;
      default:
        console.log(message);
    }

}
